import { getErrorMessage, isForbiddenError } from '@/lib/api/error';
import type { FeeRunExclusionReason } from '@/services/api/fee-runs';

/** API codes that belong on the PID field rather than in the dialog's error banner */
const PID_ERROR_MESSAGE: Readonly<Record<string, string>> = {
  USER_NOT_FOUND: 'No user found for this PID',
  INVALID_PID: 'This is not a valid PID',
};

const ERROR_MESSAGE: Readonly<Record<string, string>> = {
  ...PID_ERROR_MESSAGE,
  NOT_EXCLUDED: 'This account holder is no longer excluded',
};

export interface ExclusionError {
  field: 'pid' | null;
  message: string;
}

export const parseExclusionError = (error: unknown): ExclusionError => {
  if (isForbiddenError(error)) return { field: null, message: 'You are not authorised to manage fee exclusions' };
  const code = getErrorMessage(error);
  if (PID_ERROR_MESSAGE[code]) return { field: 'pid', message: PID_ERROR_MESSAGE[code] };
  return { field: null, message: ERROR_MESSAGE[code] ?? code };
};

/** The API's label for a reason; an unknown value (a reason since retired) is shown as stored. */
export const exclusionReasonLabel = (reasons: readonly FeeRunExclusionReason[] | undefined, value: string): string =>
  reasons?.find((reason) => reason.value === value)?.label ?? value;
